/*
PLEASE USE THE SAMPLE BANNER BLOCK PROVIDED BELOW:

{
    collection: [],
    queries: [],
    link: '',
    bannerImage: '',
    bannerPosition: 1
},

*/
document.addEventListener('Searchanise.Loaded', function () {
    (function ($) {
        function snizeAddCollectionBanner(snizeColUrl, snizeBannerUrl, snizeBannerPosition, snizeCurrentUrl, snizeCurrentQuery) {
            if (location.pathname.includes('/pages/search-results-page') && snizeCurrentQuery.length) {
                let urlParams = new URLSearchParams(window.location.search);
                let paramsQuery = urlParams.get('q');
                for (let query of snizeCurrentQuery) {
                    if (paramsQuery == query) {
                       /* $(`ul.snize-search-results-content li:nth-child(${snizeBannerPosition})`).before(`
                            <li class="snize-banner snize-custom-banner"><a href=${snizeColUrl} target="_blank"><img src=${snizeBannerUrl}></a></li>`
                        );
                        break;*/
                        const bannerHTML = snizeColUrl
                            ? `<li class="snize-banner snize-custom-banner"><a href="${snizeColUrl}" target="_blank"><img src="${snizeBannerUrl}" alt="Banner"></a></li>`
                            : `<li class="snize-banner snize-custom-banner"><img src="${snizeBannerUrl}" alt="Banner"></li>`;

                        $(`ul.snize-search-results-content li:nth-child(${snizeBannerPosition})`).before(bannerHTML);
                        break;
                    }
                }
            } else if (!location.pathname.includes('/pages/search-results-page') && snizeCurrentUrl.length) {
                for (let url of snizeCurrentUrl) {
                    if ($(location).attr('href').includes(url)) {
                        /*$(`ul.snize-search-results-content li:nth-child(${snizeBannerPosition})`).before(`
                            <li class="snize-banner snize-custom-banner"><a href=${snizeColUrl} target="_blank"><img src=${snizeBannerUrl}></a></li>`
                        );
                        break;*/
                        const bannerHTML = snizeColUrl
                            ? `<li class="snize-banner snize-custom-banner"><a href="${snizeColUrl}" target="_blank"><img src="${snizeBannerUrl}" alt="Banner"></a></li>`
                            : `<li class="snize-banner snize-custom-banner"><img src="${snizeBannerUrl}" alt="Banner"></li>`;

                        $(`ul.snize-search-results-content li:nth-child(${snizeBannerPosition})`).before(bannerHTML);
                        break;
                    }
                }
            }
        }

        let snizeBannersDataEn = [
           {
                collection: ['/advanced-firming', '/collections/anti-aging-skincare-products', '/collections/serums'],
                queries: [''],
                link: 'https://vivierskin.ca/products/vivier-gift-card?variant=39287703732339',
                bannerImage: 'https://cdn.shopify.com/s/files/1/0048/0162/6227/files/BFCM_2025_GIF.gif?v=1764004972',
                bannerPosition: 5
            },
            {
                collection: ['/collections/fan-favourites', '/collections/all', '/hyperpigmentation-treatment-products', '/collections/acne'],
                queries: [''],
                link: 'https://vivierskin.ca/pages/holiday-gift-guide',
                bannerImage: 'https://cdn.shopify.com/s/files/1/0048/0162/6227/files/BFCM_2025_GIF.gif?v=1764004972',
                bannerPosition: 5
            },
           {
                collection: ['collections/summer-essentials'],
                queries: [''],
                link: '',
                bannerImage: 'https://cdn.shopify.com/s/files/1/0048/0162/6227/files/Prepare_collection_card_-_EN_a38a41ac-82c4-49ad-8c5c-418755ef06e0.png?v=1747406112',
                bannerPosition: 1
          },
           {
                collection: ['collections/summer-essentials'],
                queries: [''],
                link: '',
                bannerImage: 'https://cdn.shopify.com/s/files/1/0048/0162/6227/files/Target_collection_card_-_EN_913ad006-4e89-4af9-85f8-0311f498a333.png?v=1747406112',
                bannerPosition: 5
            },
           {
                collection: ['collections/summer-essentials'],
                queries: [''],
                link: '',
                bannerImage: 'https://cdn.shopify.com/s/files/1/0048/0162/6227/files/Moisturize_collection_card_-_EN_5cad6e2f-22a5-467f-92f4-a612fcce055d.png?v=1747406112',
                bannerPosition: 9
            },
           {
                collection: ['collections/summer-essentials'],
                queries: [''],
                link: '',
                bannerImage: 'https://cdn.shopify.com/s/files/1/0048/0162/6227/files/Protect_collection_card_-_EN_159f8c6a-cfc4-4ba5-bc4f-ded710eefc76.png?v=1747406112',
                bannerPosition: 13
            },
        ];
  
        let snizeBannersDataFr = [
            {
                collection: ['/fr/collections/aging-skin', '/fr/collections/fan-favourites', '/fr/collections/all', '/fr/collections/serums', '/fr/collections/vitamin-c'],
                queries: [''],
                link: '',
                bannerImage: 'https://cdn.shopify.com/s/files/1/0048/0162/6227/files/FR_BF_GIF.gif?v=1764163144',
                bannerPosition: 5
            },
            {
                collection: ['/fr/collections/acne', '/hyperpigmentation-treatment-products'],
                queries: [''],
                link: '',
                bannerImage: 'https://cdn.shopify.com/s/files/1/0048/0162/6227/files/FR_BF_GIF.gif?v=1764163144',
                bannerPosition: 5
            },
          {
                collection: ['collections/summer-essentials'],
                queries: [''],
                link: '',
                bannerImage: 'https://cdn.shopify.com/s/files/1/0048/0162/6227/files/Prepare_collection_card_-_FR_9c78c699-600e-4e99-9e37-1e80fbc0672e.png?v=1747830515',
                bannerPosition: 1
          },
           {
                collection: ['collections/summer-essentials'],
                queries: [''],
                link: '',
                bannerImage: 'https://cdn.shopify.com/s/files/1/0048/0162/6227/files/Target_collection_card_-_FR_bd7f034b-ef05-4823-853a-2573ed9c29e7.png?v=1747830515',
                bannerPosition: 5
            },
           {
                collection: ['collections/summer-essentials'],
                queries: [''],
                link: '',
                bannerImage: 'https://cdn.shopify.com/s/files/1/0048/0162/6227/files/Moisturize_collection_card_-_FR_db77c1cd-a401-4312-9271-0f8ab3e89a09.png?v=1747830515',
                bannerPosition: 9
            },
           {
                collection: ['collections/summer-essentials'],
                queries: [''],
                link: '',
                bannerImage: 'https://cdn.shopify.com/s/files/1/0048/0162/6227/files/Protect_collection_card_-_FR_acdaeb81-46a4-4398-bc9d-15da3e0c53d4.png?v=1747830515',
                bannerPosition: 13
            },
        ];

        $(document).on('Searchanise.ResultsUpdated', function () {
            let snizeBannersData = Shopify.locale == 'en' ? snizeBannersDataEn : snizeBannersDataFr;
            if (!$('.snize-custom-banner').length) {
                snizeBannersData.forEach(function (bannerData) {
                    snizeAddCollectionBanner(bannerData.link, bannerData.bannerImage, bannerData.bannerPosition, bannerData.collection, bannerData.queries);
                });
            }
        });
    })(window.Searchanise.$);
});
